var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27956"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27950"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9086",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Settings-alt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18a1.059 1.059 0 0 1-.768-.326l-1.982-2.05H3.444a1.07 1.07 0 0 1-1.068-1.068V11.75L.326 9.768a1.068 1.068 0 0 1 0-1.536l2.05-1.982V3.444a1.07 1.07 0 0 1 1.068-1.068H6.25L8.232.326a1.068 1.068 0 0 1 1.536 0l1.982 2.05h2.805a1.07 1.07 0 0 1 1.068 1.068V6.25l2.05 1.982a1.068 1.068 0 0 1 0 1.536l-2.05 1.982v2.805a1.07 1.07 0 0 1-1.068 1.068H11.75l-1.982 2.05A1.059 1.059 0 0 1 9 18zM3.658 3.658V6.34a1.075 1.075 0 0 1-.326.768L1.376 9l1.956 1.891a1.075 1.075 0 0 1 .326.768v2.682H6.34a1.075 1.075 0 0 1 .768.326L9 16.625l1.891-1.957a1.075 1.075 0 0 1 .768-.326h2.682v-2.683a1.075 1.075 0 0 1 .326-.768L16.625 9l-1.957-1.891a1.075 1.075 0 0 1-.326-.768V3.658h-2.683a1.075 1.075 0 0 1-.768-.326L9 1.376 7.109 3.332a1.075 1.075 0 0 1-.768.326H3.658z",
    transform: "translate(3 3)",
    style: {
      fill: "#8c8d99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M4.06 8.12a4.06 4.06 0 1 1 4.06-4.06 4.064 4.064 0 0 1-4.06 4.06zm0-6.838A2.778 2.778 0 1 0 6.838 4.06 2.781 2.781 0 0 0 4.06 1.282z",
    transform: "translate(7.94 7.94)",
    style: {
      fill: "#1bc47d"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingColored);
export default __webpack_public_path__ + "static/media/setting-colored.10f59388d777825d76c7a4cf8984b40c.svg";
export { ForwardRef as ReactComponent };